module.exports = "#container{\n    position: absolute;\n    margin: auto;\n    max-width: 650px;\n    left: 0;\n    right: 0;\n    height: 100%;\n}"